// Tentative distance inputs (spec section 5) - replace with a lane distance
// master (origin pincode, destination pincode, km) once one exists.
//
// PINCODE_AREAS: first 3 digits of a pincode -> [lat, lng] (~410 areas).
// SOURCE_LOCATIONS: full source pincode -> [lat, lng] (plants / warehouses
// use their own coordinates rather than the area centroid).
// LANE_KM: optional override, "originPin-destPin" -> road km. When present it
// wins over the great-circle estimate.
//
// Load these from the prototype's coordinate CSV handed over with the spec.
// Rows whose pincodes are not covered show "Needs distance" and are left out
// of CO2 - never guessed.

export const PINCODE_AREAS = {};

export const SOURCE_LOCATIONS = {};

export const LANE_KM = {};
